import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  standalone: false,
  selector: 'mtn-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent  {

  @Output()
  iconButtonClick = new EventEmitter<any>();
  @Input()
  color: ThemePalette;
  @Input()
  disabled = false;
  @Input()
  isMini = false;


  doClick(event: MouseEvent): void {
    if (!this.disabled) {
      this.iconButtonClick.emit(event);
    }
  }

}
